import { navbarActions } from './NavBarActions';

const initState = {
    unSeenMessages: 0,
    error: null,
    notifList: [],
    notifsCount: 0,
    showNotifsList: false
}

export default function navBarReducer(state = initState, action) {
    switch (action.type) {
        case navbarActions.setUnSeenMessages:
            return setUnSeenMessages(state, action);
        case navbarActions.setError:
            return setError(state, action);
        case navbarActions.setNotifList:
            return setNotifList(state, action);
        case navbarActions.setNotifsCount:
            return setNotifsCount(state, action);
        case navbarActions.toggleNotifsList:
            return toggleNotifsList(state, action);
        case navbarActions.hideNotifsList:
            return hideNotifsList(state);
        default:
            return state;
    }
}


function toggleNotifsList(state, { payload }) {
    return {
        ...state,
        showNotifsList: payload
    }
}

function hideNotifsList(state) {
    return {
        ...state,
        showNotifsList: false
    }
}

function setUnSeenMessages(state, { payload }) {
    return {
        ...state,
        unSeenMessages: payload
    }
}

function setError(state, { payload }) {
    return {
        ...state,
        error: payload,
    }
}

function setNotifList(state, { payload }) {
    return {
        ...state,
        notifList: payload
    }
}


function setNotifsCount(state, { payload }) {
    return {
        ...state,
        notifsCount: payload
    }
}